import React, { createContext, useContext } from 'react';

import { COMPANY_INITIAL_VALUES } from './constants';
import { CompanyListItemType } from '../table/types';

type CompaniesCreateEditModalContent = {
  company: CompanyListItemType;
  handleChange: (key: keyof CompanyListItemType, value: any) => void;
  handleSave: () => void;
  onClose: () => void;
};

export const CompaniesCreateEditModalContext = createContext<CompaniesCreateEditModalContent>({
  company: COMPANY_INITIAL_VALUES,
  handleChange: (key: keyof CompanyListItemType, value: any) => {
    // Do nothing
  },
  handleSave: () => {
    // Do nothing
  },
  onClose: () => {
    // Do nothing
  },
});

export const useCompaniesCreateEditModalContext = () => useContext(CompaniesCreateEditModalContext);
